//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirmation from '../../layout/Confirmation';

export default {
  name: 'PwrUnauthenticated',
  components: { Confirmation },
  props: {
    rootClass: {
      default: 'root',
    },
  },
};
